<template>
  <div
    class="evidence-upload-zone d-flex flex-column align-items-center gap-2 small text-dark"
    :class="{ dragging }"
    @dragover.prevent="dragging = true"
    @dragleave="dragging = false"
    @drop.prevent="onDrop"
    @click="$refs.fileInput.click()"
  >
    <div v-if="success" class="d-flex align-items-center gap-2 small text-success">
      <i class="bi bi-check-circle-fill" />
      Uploaded successfully
    </div>
    <div v-else-if="uploading" class="d-flex align-items-center gap-2 small">
      <spinner-view small />
      Uploading...
    </div>
    <div v-else-if="error" class="small text-danger">
      {{ error }}
      <a href="#" @click.prevent.stop="error = null">Try again</a>
    </div>
    <template v-else>
      <i class="bi-cloud-arrow-up" />
      <div>Drop a PNG or JPG, or click to browse</div>
    </template>
  </div>
  <input ref="fileInput" accept="image/png,image/jpeg" type="file" style="display: none;" @change="onFileSelected">
</template>

<script>
import SpinnerView from '@/components/common/SpinnerView.vue';
import { requestApi } from '@/api';

export default {
  components: { SpinnerView },
  props: {
    cityId: { type: String, required: true },
    listingId: { type: String, required: true }
  },
  emits: ['uploaded'],
  data() {
    return {
      dragging: false,
      uploading: false,
      error: null,
      success: false
    };
  },
  methods: {
    onDrop(event) {
      this.dragging = false;
      const file = event.dataTransfer?.files?.[0];
      if (file) {
        this.upload(file);
      }
    },
    onFileSelected(event) {
      const file = event.target?.files?.[0];
      if (file) {
        this.upload(file);
      }
    },
    async upload(file) {
      if (!file.type.match(/^image\/(png|jpeg)$/)) {
        this.error = 'Only PNG and JPEG files are supported.';
        return;
      }

      this.uploading = true;
      this.error = null;

      try {
        const formData = new FormData();
        formData.append('file', file);
        await requestApi(
          `/v1/cities/${this.cityId}/listings/${this.listingId}/evidence/upload`,
          { method: 'POST', body: formData }
        );

        this.success = true;
        setTimeout(() => {
          this.success = false;
          this.$emit('uploaded');
        }, 1200);
        return;
      } catch (err) {
        this.error = err.message || 'Upload failed';
      } finally {
        this.uploading = false;
      }
    }
  }
};
</script>

<style scoped>
.evidence-upload-zone {
  border: 1.5px dashed #d6d3d1;
  border-radius: 4px;
  padding: 0.5rem 0.75rem;
  transition: border-color 0.15s, background-color 0.15s;
  cursor: pointer;
}
.evidence-upload-zone:hover {
  border-color: #78716c;
  background: #f5f4f3;
}
.evidence-upload-zone.dragging {
  border-color: var(--bs-primary);
  background-color: rgba(var(--bs-primary-rgb), 0.05);
}
</style>
